module.exports = __webpack_public_path__ + "static/media/make-public.ba411dc8.svg";